export const convertCurrencyToCountryCodes = (currency: string): string[] => {
  return currencyToCountryMap[currency] ?? ["XX"]; // Default to 'XX' for unknown currencies
};

// Complete mapping of currency codes to country codes
export const currencyToCountryMap: Record<string, string[]> = {
  AFN: ["AF"], // Afghan Afghani
  ALL: ["AL"], // Albanian Lek
  DZD: ["DZ"], // Algerian Dinar
  USD: ["US"], // United States Dollar
  EUR: ["EU"], // Euro (used in Eurozone countries)
  AOA: ["AO"], // Angolan Kwanza
  XCD: ["AG", "DM", "GD", "KN", "LC", "VC"], // East Caribbean Dollar
  ARS: ["AR"], // Argentine Peso
  AMD: ["AM"], // Armenian Dram
  AWG: ["AW"], // Aruban Florin
  AUD: ["AU"], // Australian Dollar
  AZN: ["AZ"], // Azerbaijani Manat
  BSD: ["BS"], // Bahamian Dollar
  BHD: ["BH"], // Bahraini Dinar
  BDT: ["BD"], // Bangladeshi Taka
  BBD: ["BB"], // Barbadian Dollar
  BYR: ["BY"], // Belarusian Ruble (replaced by BYN)
  BZD: ["BZ"], // Belize Dollar
  XOF: ["BF", "BJ", "CI", "ML", "NE", "SN", "TG"], // West African CFA Franc
  BMD: ["BM"], // Bermudian Dollar
  INR: ["IN"], // Indian Rupee
  BTN: ["BT"], // Bhutanese Ngultrum
  BOB: ["BO"], // Bolivian Boliviano
  BOV: ["BO"], // Bolivian Mvdol
  BAM: ["BA"], // Bosnia and Herzegovina Convertible Mark
  BWP: ["BW"], // Botswanan Pula
  NOK: ["NO"], // Norwegian Krone
  BRL: ["BR"], // Brazilian Real
  BND: ["BN"], // Bruneian Dollar
  BGN: ["BG"], // Bulgarian Lev
  BIF: ["BI"], // Burundian Franc
  KHR: ["KH"], // Cambodian Riel
  XAF: ["CM", "CF", "CG", "GQ", "TD"], // Central African CFA Franc
  CAD: ["CA"], // Canadian Dollar
  CVE: ["CV"], // Cape Verdean Escudo
  KYD: ["KY"], // Cayman Islands Dollar
  CLP: ["CL"], // Chilean Peso
  CLF: ["CL"], // Chilean Unidad de Fomento
  CNY: ["CN"], // Chinese Yuan
  COP: ["CO"], // Colombian Peso
  COU: ["CO"], // Colombian Unidad de Valor Real
  KMF: ["KM"], // Comorian Franc
  CDF: ["CD"], // Congolese Franc
  NZD: ["NZ"], // New Zealand Dollar
  CRC: ["CR"], // Costa Rican Colón
  HRK: ["HR"], // Croatian Kuna
  CUP: ["CU"], // Cuban Peso
  CYP: ["CY"], // Cypriot Pound (replaced by EUR)
  CZK: ["CZ"], // Czech Koruna
  DKK: ["DK"], // Danish Krone
  DJF: ["DJ"], // Djiboutian Franc
  DOP: ["DO"], // Dominican Peso
  EGP: ["EG"], // Egyptian Pound
  SVC: ["SV"], // Salvadoran Colón
  ERN: ["ER"], // Eritrean Nakfa
  EEK: ["EE"], // Estonian Kroon (replaced by EUR)
  ETB: ["ET"], // Ethiopian Birr
  FKP: ["FK"], // Falkland Islands Pound
  FJD: ["FJ"], // Fijian Dollar
  XPF: ["PF", "NC", "WF"], // CFP Franc
  GMD: ["GM"], // Gambian Dalasi
  GEL: ["GE"], // Georgian Lari
  GHC: ["GH"], // Ghanaian Cedi (replaced by GHS)
  GIP: ["GI"], // Gibraltar Pound
  GTQ: ["GT"], // Guatemalan Quetzal
  GNF: ["GN"], // Guinean Franc
  GWP: ["GW"], // Guinea-Bissau Peso
  GYD: ["GY"], // Guyanese Dollar
  HTG: ["HT"], // Haitian Gourde
  HNL: ["HN"], // Honduran Lempira
  HKD: ["HK"], // Hong Kong Dollar
  HUF: ["HU"], // Hungarian Forint
  ISK: ["IS"], // Icelandic Króna
  IDR: ["ID"], // Indonesian Rupiah
  IRR: ["IR"], // Iranian Rial
  IQD: ["IQ"], // Iraqi Dinar
  ILS: ["IL"], // Israeli New Shekel
  JMD: ["JM"], // Jamaican Dollar
  JPY: ["JP"], // Japanese Yen
  JOD: ["JO"], // Jordanian Dinar
  KZT: ["KZ"], // Kazakhstani Tenge
  KES: ["KE"], // Kenyan Shilling
  KPW: ["KP"], // North Korean Won
  KRW: ["KR"], // South Korean Won
  KWD: ["KW"], // Kuwaiti Dinar
  KGS: ["KG"], // Kyrgystani Som
  LAK: ["LA"], // Laotian Kip
  LVL: ["LV"], // Latvian Lats (replaced by EUR)
  LBP: ["LB"], // Lebanese Pound
  ZAR: ["ZA"], // South African Rand
  LSL: ["LS"], // Lesotho Loti
  LRD: ["LR"], // Liberian Dollar
  LYD: ["LY"], // Libyan Dinar
  CHF: ["CH"], // Swiss Franc
  LTL: ["LT"], // Lithuanian Litas (replaced by EUR)
  MOP: ["MO"], // Macanese Pataca
  MKD: ["MK"], // Macedonian Denar
  MGA: ["MG"], // Malagasy Ariary
  MWK: ["MW"], // Malawian Kwacha
  MYR: ["MY"], // Malaysian Ringgit
  MVR: ["MV"], // Maldivian Rufiyaa
  MTL: ["MT"], // Maltese Lira (replaced by EUR)
  MRO: ["MR"], // Mauritanian Ouguiya (replaced by MRU)
  MUR: ["MU"], // Mauritian Rupee
  MXN: ["MX"], // Mexican Peso
  MXV: ["MX"], // Mexican Unidad de Inversion
  MDL: ["MD"], // Moldovan Leu
  MNT: ["MN"], // Mongolian Tugrik
  MAD: ["MA"], // Moroccan Dirham
  MZN: ["MZ"], // Mozambican Metical
  MMK: ["MM"], // Myanmar Kyat
  NAD: ["NA"], // Namibian Dollar
  NPR: ["NP"], // Nepalese Rupee
  ANG: ["AW", "BQ", "CW"], // Netherlands Antillean Guilder
  NIO: ["NI"], // Nicaraguan Córdoba
  NGN: ["NG"], // Nigerian Naira
  OMR: ["OM"], // Omani Rial
  PKR: ["PK"], // Pakistani Rupee
  PAB: ["PA"], // Panamanian Balboa
  PGK: ["PG"], // Papuan Kina
  PYG: ["PY"], // Paraguayan Guarani
  PEN: ["PE"], // Peruvian Nuevo Sol
  PHP: ["PH"], // Philippine Peso
  PLN: ["PL"], // Polish Zloty
  QAR: ["QA"], // Qatari Rial
  ROL: ["RO"], // Romanian Leu (replaced by RON)
  RON: ["RO"], // Romanian Leu
  RUB: ["RU"], // Russian Ruble
  RWF: ["RW"], // Rwandan Franc
  SHP: ["SH"], // Saint Helena Pound
  WST: ["WS"], // Samoan Tala
  STD: ["ST"], // São Tomé and Príncipe Dobra (replaced by STN)
  SAR: ["SA"], // Saudi Riyal
  RSD: ["RS"], // Serbian Dinar
  SCR: ["SC"], // Seychellois Rupee
  SLL: ["SL"], // Sierra Leonean Leone
  SGD: ["SG"], // Singapore Dollar
  SKK: ["SK"], // Slovak Koruna (replaced by EUR)
  SIT: ["SI"], // Slovenian Tolar (replaced by EUR)
  SBD: ["SB"], // Solomon Islands Dollar
  SOS: ["SO"], // Somali Shilling
  LKR: ["LK"], // Sri Lankan Rupee
  SDG: ["SD"], // Sudanese Pound
  SRD: ["SR"], // Surinamese Dollar
  SZL: ["SZ"], // Swazi Lilangeni
  SEK: ["SE"], // Swedish Krona
  CHW: ["CH"], // Swiss Franc (WIR)
  CHE: ["CH"], // Swiss Franc (E-gold)
  SYP: ["SY"], // Syrian Pound
  TWD: ["TW"], // New Taiwan Dollar
  TJS: ["TJ"], // Tajikistani Somoni
  TZS: ["TZ"], // Tanzanian Shilling
  THB: ["TH"], // Thai Baht
  TOP: ["TO"], // Tongan Paʻanga
  TTD: ["TT"], // Trinidad and Tobago Dollar
  TND: ["TN"], // Tunisian Dinar
  TRY: ["TR"], // Turkish Lira
  TMM: ["TM"], // Turkmenistani Manat (replaced by TMT)
  UGX: ["UG"], // Ugandan Shilling
  UAH: ["UA"], // Ukrainian Hryvnia
  AED: ["AE"], // United Arab Emirates Dirham
  GBP: ["GB"], // British Pound Sterling
  USS: ["US"], // United States Dollar (Special Account)
  USN: ["US"], // United States Dollar (Next Day)
  UYU: ["UY"], // Uruguayan Peso
  UYI: ["UY"], // Uruguayan Indexable Unit
  UZS: ["UZ"], // Uzbekistani
  VUV: ["VU"], // Vanuatu Vatu
  VEB: ["VE"], // Venezuelan Bolívar (replaced by VES)
  VND: ["VN"], // Vietnamese Dong
  YER: ["YE"], // Yemeni Rial
  ZMK: ["ZM"], // Zambian Kwacha (replaced by ZMW)
  ZWD: ["ZW"], // Zimbabwean Dollar (replaced by ZWL)
  BYN: ["BY"], // Belarusian Ruble
  VEF: ["VE"], // Venezuelan Bolívar (replaced by VES)
  SSP: ["SS"], // South Sudanese Pound
  TMT: ["TM"], // Turkmenistani Manat
  ZMW: ["ZM"], // Zambian Kwacha
  ZWL: ["ZW"], // Zimbabwean Dollar (new version)
  VES: ["VE"], // Venezuelan Sovereign Bolívar
  GHS: ["GH"], // Ghanaian Cedi
};
